module.exports = __webpack_public_path__ + "static/media/swap.9c2c6884.svg";